import React, { useEffect, useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import Indemnizacion from "../cards/Indemnizacion";
// import VariacionDatosPersonalCard from "../cardsNoResumen/VariacionDatosPersonalCard";
// import ReconocimientoNivelNoResumen from "../cardsNoResumen/ReconocimientoNivelNoResumen";
import ActosCard from "../cardsNoResumen/ActosCard";
import "../cardsNoResumen/cardNoResumen.scss";
//import CambioCuentaCorrienteCard from "../cardsNoResumen/CambioCuentaCorrienteCard";
// import ReconNivelCarreraCard from "../cardsNoResumen/ReconNivelCarreraCard";
const TramLab = () => {
  const [isVisible, initHs] = useState(true);
  const invokeCollapse = () => {
    return initHs(!isVisible);
  };

  useEffect(() => {}, []);

  return (
    <>
      <div className="container-fluid">
        <div className="" 
        onClick={invokeCollapse}
        role="button" 
        tabIndex={0} 
        title="Desplegar mis trámites"
        aria-label="Desplegar mis trámites"
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault()
            invokeCollapse()
          }
        }}
        >
          {/* <TituloCaja
            tipo={"tituloModal dropdown-toggle link"}
            titulo={"Mis trámites"}
          ></TituloCaja> */}
          <h2 className="tituloModal dropdown-toggle link">Mis trámites</h2>
        </div>
        <Collapse in={isVisible}>
          <div id="collapsePanel">
            <div className="card-group d-flex flex-column flex-md-row row">
              <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                <Indemnizacion></Indemnizacion>
              </div>
              {/* <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                <VariacionDatosPersonalCard />
              </div> */}
              {/* <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                <ReconocimientoNivelNoResumen></ReconocimientoNivelNoResumen>
              </div> */}
              <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                <ActosCard/>
              </div>
              {/* <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                <ReconNivelCarreraCard/>
              </div> */}
              {/* <div className="col-sm-12 col-md-6 col-md-3 col-lg-3 col-lg-3 col-xl-3 col-xxl-3">
                <CambioCuentaCorrienteCard/>
              </div> */}
            </div>
          </div>
        </Collapse>
      </div>
    </>
  );
};
export default TramLab;
